"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogMetadata_1 = require("../config/LogMetadata");
const TimeUtils_1 = require("../util/TimeUtils");
class OnelineLogFormat {
    format(msg, metadata) {
        const time = msg.time_iso || new Date(msg.timestamp).toISOString() || TimeUtils_1.TimeUtils.getUTCISOTime();
        const name = LogMetadata_1.LogMetadata.getBestIdentifier(metadata);
        return `${name} | ${time} [${msg.level}]: ${msg.message}`;
    }
    getName() {
        return OnelineLogFormat.FORMAT_NAME;
    }
}
OnelineLogFormat.FORMAT_NAME = "oneline";
exports.OnelineLogFormat = OnelineLogFormat;
//# sourceMappingURL=OnelineLogFormat.js.map